import { matchPath } from 'react-router-dom';

export default function isWebchatBlockedRoute(
  pathname: string,
  blockedRoutes: string[],
): boolean {
  return blockedRoutes.some(path => matchPath(pathname, { path }) !== null);
}
